import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';
import merge from 'lodash/merge';
import { setContactInfo } from 'features/profile/helpers';
import { ValidationService } from 'shared/services';
import { errorStrings } from 'shared/validations';
import * as rules from 'features/profile/rules';
import { DisplayInfo } from 'shared/components';
import { RegisterProfile } from 'features/register';
import { PersonnelModel } from 'core/userModel';

class ContactInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: new PersonnelModel(props.user),
      errors: {},
      info: setContactInfo(props.user, props.t),
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.handleFormChange = this.handleFormChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user !== this.props.user) {
      this.setState({
        user: new PersonnelModel(this.props.user),
        info: setContactInfo(this.props.user ? this.props.user : {}, this.props.t),
      });
    }
  }

  onSubmit(e) {
    e.preventDefault();

    const errors = ValidationService.validate(this.state.user, rules.validationRules, errorStrings);

    if (isEmpty(errors)) {
      this.props.onSave(this.state.user, 0);
    } else {
      this.setState({
        errors,
      });
    }
  }

  handleFormChange(e) {
    let newState = { ...this.state };
    if (e.target) {
      newState.user = {
        ...this.state.user,
        [e.target.name]: e.target.value,
      };
      newState.errors = {
        ...this.state.errors,
        [e.target.name]: null,
      };
    } else {
      newState = merge({}, newState, e);
    }
    const errors = ValidationService.validate(newState.user, rules.onTypeRules, errorStrings);

    if (!isEmpty(errors)) {
      this.setState({
        errors,
      });
      return;
    }

    this.setState(newState);
  }

  render() {
    const { editInfo, serverError } = this.props;
    if (editInfo) {
      return (
        <section className="profile-content contact-info">
          <RegisterProfile
            user={this.state.user}
            onChange={this.handleFormChange}
            onSubmit={this.onSubmit}
            onCancel={() => this.props.cancel(0)}
            errors={this.state.errors}
            serverError={serverError}
            reviewInfo={isUndefined(this.props.reviewInfo) ? true : this.props.reviewInfo}
          />
        </section>
      );
    }
    return (
      <div>
        <DisplayInfo
          info={this.state.info}
          onEdit={() => this.props.onEdit('contact')}
          buttonLabel="common.labels.updateInfo"
        />

        <div className="mt-4">
          <Link to="/change-password">{this.props.t('profile.changePassword')}</Link>
        </div>
      </div>
    );
  }
}

ContactInfo.propTypes = {
  onEdit: PropTypes.func,
  editInfo: PropTypes.bool,
  cancel: PropTypes.func,
  onSave: PropTypes.func,
  user: PropTypes.shape({}).isRequired,
  serverError: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  reviewInfo: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

ContactInfo.defaultProps = {
  editInfo: false,
  onEdit: () => {},
  cancel: () => {},
  onSave: () => {},
};

export default withTranslation()(ContactInfo);
